<script lang="ts" setup>
import { ref } from "vue";
import { authService } from "@/app/services/AuthService";
import AppButton from "@/components/atoms/button/AppButton.vue";
import PasswordInputGroup from "@/components/molecules/form/PasswordInputGroup.vue";
import Header from "@/components/organisms/common/Header.vue";
import BlockBack from "@/components/organisms/common/BlockBack.vue";
import { authStore } from "@/store/auth";
import { useLoader } from "@/utils/loader";
import { useErrorModal, useModal } from "@/utils/modal";
import { useCustomRouter } from "@/utils/router";

const errorModal = useErrorModal();
const modal = useModal();
const loader = useLoader();
const customRouter = useCustomRouter();

const password = ref("");

async function nextStep() {
  try {
    loader.show();
    await registration();
    await modal.msgBoxOk(
      "パスワードの再設定が完了しました\n再度ログインしてください",
      {
        centered: true
      }
    );
    authStore.logout();
    await customRouter.pushIgnoreError({ name: "Welcome" });
  } catch (e) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const err = e as any;
    // smsSessionIdが不正な場合
    if (err.response?.data.smsSessionId) {
      await modal.msgBoxOk("不正な操作です", {
        centered: true
      });
      await customRouter.pushIgnoreError({ name: "Welcome" });
      return;
    }
    // それ以外の場合
    await errorModal.showErrorModal(err);
  } finally {
    loader.hide();
  }
}

function registration() {
  const body = {
    smsSessionId: authStore.smsSessionId as string,
    password: password.value
  };
  return authService.requestWorkerPasswordReset(body);
}
</script>

<template>
  <div>
    <Header>
      パスワード再設定
    </Header>
    <div class="my-5 mx-4">
      <div class="p-4 text-center">
        <AuthCompletion />
      </div>
      <p class="mb-4 text-weight-500 text-center">
        パスワードリセットの認証が完了しました<br />パスワードを再設定してください
      </p>
      <CustomValidationObserver
        ref="form"
        v-slot="{ handleSubmit }"
        tag="div"
        class="w-100"
      >
        <BForm @submit.stop.prevent="handleSubmit(nextStep)">
          <PasswordInputGroup
            v-model="password"
            class="mb-4"
            data-testid="password"
          />
          <AppButton
            block
            @click="handleSubmit(nextStep)"
            data-testid="submitButton"
          >
            設定して次へ
          </AppButton>
        </BForm>
      </CustomValidationObserver>
    </div>
    <BlockBack />
  </div>
</template>
